






import { Component, Vue } from "vue-property-decorator";
import AuditPembersihanLingkunganList from "@/components/ppi/audit-pembersihan-lingkungan/AuditPembersihanLingkunganList.vue";

@Component({
  components: { AuditPembersihanLingkunganList }
})
export default class AuditPembersihanLingkunganPage extends Vue {}
